import type { TabItem } from '@naf-simba/sections-tabs';

/**
 * Narrowing filter for tab lists built with conditional entries:
 *
 *   items={[alwaysThere, hasTest && testTab].filter(isTabItem)}
 *
 * `.filter(Boolean)` leaves `false` in the element type, so the array does not satisfy `TabItem[]`
 * without a cast.
 */
export const isTabItem = (item: TabItem | false | undefined | null): item is TabItem => Boolean(item);
